import { css } from '@emotion/css';
import { theme } from 'core/theme';

export const root = css`
  z-index: ${theme.zIndex.tooltip};
`;

export const closeIcon = css`
  position: absolute;
  right: 8px;
  top: 8px;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
`;

export const buttonContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
  button {
    width: 100%;
  }

  ${theme.breakpoints.up('sm')} {
    flex-direction: row;
    button {
      width: auto;
    }
  }
`;
